import { Info } from '@phosphor-icons/react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { QuoteEntityType, QuoteNoteType } from 'quotes/enums';
import { IVendorQuote } from 'quotes/types';
import { getQuoteNoteContent } from 'quotes/utils';
import { Color, Variant } from 'theme/enums';

import { VendorQuoteDetails } from './VendorQuoteDetails';

interface IProps {
  quote: IVendorQuote;
  quoteEntityType?: QuoteEntityType;
}

export const VendorQuoteDetailsButton = ({
  quote,
  quoteEntityType = QuoteEntityType.QUOTE,
}: IProps) => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  const { t } = useTranslation();

  const badges = useMemo(() => {
    const badgeProps = [];

    if (getQuoteNoteContent(quote, QuoteNoteType.CUSTOMER_NOTE)) {
      badgeProps.push({ key: QuoteNoteType.CUSTOMER_NOTE, color: Color.DANGER });
    }

    return badgeProps;
  }, [quote]);

  return (
    <>
      <Button
        text={t('buttonLabelQuoteDetails', { entityType: quoteEntityType })}
        startDecorator={<Info />}
        variant={Variant.OUTLINED}
        onClick={() => setIsDetailsOpen(true)}
        badges={badges}
      />

      <VendorQuoteDetails
        isOpen={isDetailsOpen}
        setIsOpen={setIsDetailsOpen}
        quote={quote}
        entityType={quoteEntityType}
      />
    </>
  );
};
